import {
  REDUCER_NAMES_FETCH_STATUSES_UNIVERSAL_CUSTOMER_REPS,
} from '../../../constants'
import getFetchStatusSelectors from './HOF/fetchStatusSelectors'

export default getFetchStatusSelectors()(
  REDUCER_NAMES_FETCH_STATUSES_UNIVERSAL_CUSTOMER_REPS,
)
